export class BuilderModel
{
    public Id: number | null = null;

    public Name: string | null = null;

    public Domain: string | null = null;

    public ButtonForegroundColor: string = '#EEEEEE'

    public ButtonBackgroundColor: string = '#000000'

    public ButtonIcon: string = "default";

    public CanAddFiles: boolean = true;

    public CanAddScreenshot: boolean = true;
}
